document.addEventListener('DOMContentLoaded', function () {
    // Only apply hover behavior on desktop (screens > 1006px)
    if (window.innerWidth <= 1006) return;

    // Get all first-level menu item buttons
    const menuButtons = document.querySelectorAll(
        '#menu-drawer .menu-drawer__menu > li > button'
    );
    let activeSubmenu = null;
    let activeButton = null;

    menuButtons.forEach(function (button) {
        const submenuDiv = button.nextElementSibling; // The div with id='link-...'

        // Mouse enter event on button
        button.addEventListener('mouseenter', function (e) {
            // Hide the previously active submenu if different
            if (activeSubmenu && activeSubmenu !== submenuDiv) {
                activeSubmenu.classList.remove('tw-block');
                activeSubmenu.classList.add('tw-hidden');
            }

            // Show this submenu and keep it open
            if (submenuDiv) {
                submenuDiv.classList.remove('tw-hidden');
                submenuDiv.classList.add('tw-block');
                activeSubmenu = submenuDiv;
                activeButton = button;
            }
        });

        // Keep submenu open when hovering over it
        if (submenuDiv) {
            submenuDiv.addEventListener('mouseenter', function (e) {});

            submenuDiv.addEventListener('mouseleave', function (e) {
                // Hide immediately when leaving submenu
                this.classList.remove('tw-block');
                this.classList.add('tw-hidden');
                if (activeSubmenu === this) {
                    activeSubmenu = null;
                    activeButton = null;
                }
            });
        }
    });

    // Close submenu when clicking outside
    document.addEventListener('click', function (e) {
        // Check if click is outside the active button and submenu
        if (activeSubmenu && activeButton) {
            if (!activeButton.contains(e.target) && !activeSubmenu.contains(e.target)) {
                activeSubmenu.classList.remove('tw-block');
                activeSubmenu.classList.add('tw-hidden');
                activeSubmenu = null;
                activeButton = null;
            }
        }
    });

    // Handle window resize
    window.addEventListener('resize', function () {
        if (window.innerWidth <= 1006) {
            // Reset all submenu displays on mobile
            document
                .querySelectorAll('#menu-drawer .menu-drawer__menu > li > button + div')
                .forEach(function (div) {
                    div.classList.remove('tw-block');
                    div.classList.add('tw-hidden');
                });
            activeSubmenu = null;
            activeButton = null;
        }
    });
});